import { toMoney } from "utils/string_utils"

export const GetRelativePricing = (price, basePrice) => {
  // basically convert price to relative price based on base price
  if (price === basePrice) {
    return "No change in price"
  }

  if (price > basePrice) {
    const diffPrice = price - basePrice
    return `${toMoney(diffPrice)} more a month`
  }

  const diffPrice = basePrice - price
  return `${toMoney(diffPrice)} less a month`
}

export const GetRelativeOOCPricing = (price, basePrice) => {
  // basically convert price to relative price based on base price
  if (price === basePrice) {
    return "No change in price than you pay currently"
  }

  if (price > basePrice) {
    const diffPrice = price - basePrice
    return `${toMoney(diffPrice)} more than you pay currently`
  }

  const diffPrice = basePrice - price
  return `${toMoney(diffPrice)} less than you pay currently`
}
